export default class CustomersApi {
  constructor(client, url) {
    this.url = url
    this.client = client
  }

  unsubscribe(token, params) {
    return this.client.delete(`${this.url}/${token}/unsubscribe`, { data: params }).then((response) => response.data)
  }
}
